import { collectUrl } from "../constants/variables";
import DOMPurify from "dompurify";
import React from "react";

export const normalizeTimestamp = (t) => {
  if (!t) return null;
  let timestamp = Number(t);
  if (isNaN(timestamp)) return null;

  const digits = Math.floor(Math.log10(timestamp)) + 1;

  if (digits >= 18) { // Nanoseconds
    timestamp = timestamp / 1000000;
  } else if (digits >= 15) { // Microseconds
    timestamp = timestamp / 1000;
  } else if (digits <= 10) { // Seconds
    timestamp = timestamp * 1000;
  }
  // else it's likely milliseconds

  return timestamp;
};

export const extractData = (dataSale, data) => {
  const { sale_type, sales_date, org_id, sale_trx_code } = dataSale;
  const { saledata } = data?.data || {};
  const { paylink_id } = saledata || {};
  // const paylink_id = saledata?.paylink_id;

  const timestamp = normalizeTimestamp(sales_date) || new Date().getTime();
  const original_date = formatDate(new Date(timestamp));

  return {
    type: sale_type,
    org_id,
    sales_code: sale_trx_code,
    paylink_id,
    original_date,
  };
};

export const formatDate = (date) => {
  const todate = date.getDate();
  const tomonth = date.getMonth() + 1;
  const toyear = date.getFullYear();
  return `${todate}/${tomonth}/${toyear}`;
};

export const handleCardClick = (name, number) => {
  const newPageUrl = `${collectUrl}/register?name=${encodeURIComponent(
    name
  )}&number=${encodeURIComponent(number?.replace(/^0/, "254"))}`;
  window.open(newPageUrl, "_blank");
};

export const handleCloseThisModal = (setIsToOpen) => {
  window.location.reload();
  setIsToOpen(false);
};

export const titleCase = (str) => {
  return str?.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const sanitizePhoneNumber = (inputValue) => {
  const sanitizedValue = inputValue || "";
  let truncatedLength = 12;
  if (sanitizedValue.startsWith("254")) {
    truncatedLength = 12;
  } else if (sanitizedValue.startsWith("0")) {
    truncatedLength = 10;
  } else {
    if (sanitizedValue.length > 5) {
      truncatedLength = sanitizedValue.length;
    }
  }
  return {
    sanitizedValue: sanitizedValue.substring(0, truncatedLength),
    length: truncatedLength,
  };
};

export const handleInput = (e, cardOption) => {
  const inputValue = e?.target ? e?.target?.value : e;
  if (cardOption) {
    return { number: inputValue, length: Math.max(4, inputValue?.length) };
  }
  const { sanitizedValue, length } = sanitizePhoneNumber(inputValue);
  return { number: sanitizedValue, length };
};

export const handleInputSurvey = (e, setPhoneLength, setNumber) => {
  const inputValue = e?.target?.value;
  const { sanitizedValue, length } = sanitizePhoneNumber(inputValue);
  setPhoneLength(length);
  setNumber(sanitizedValue);
};

export const handleInputPledge = (e) => {
  const inputValue = e?.target?.value;
  const { sanitizedValue, length } = sanitizePhoneNumber(inputValue);
  return { number: sanitizedValue, length };
};

export const handleInputChange1 = (e, setName) => {
  setName(e.target.value);
};

export const handleInputChange2 = (e) => {
  const inputValue = e.target.value;
  const { sanitizedValue, length } = sanitizePhoneNumber(inputValue);
  return { number: sanitizedValue, length };
};

export const handleInputChange3 = (e, setAmount) => {
  setAmount(e.target.value);
};

export const downloadPdf = (base64String, fileName) => {
  try {
    const binaryString = atob(base64String);
    const binaryData = new Uint8Array(
      [...binaryString].map((char) => char.charCodeAt(0))
    );
    const blob = new Blob([binaryData], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
  } catch (error) {
    console.error("Failed to download PDF", error);
  }
};

export const timeDate = (t) => {
  if (!t) return null;
  const dateRegex = /^(?:(?:19|20)\d\d)-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;

  if (dateRegex.test(t)) {
    return t;
  }

  const timestamp = normalizeTimestamp(t);
  if (!timestamp) return null;

  const date = new Date(timestamp);

  if (isNaN(date.getTime())) {
    return null;
  }

  const todate = date.getDate();
  const tomonth = date.getMonth() + 1;
  const toyear = date.getFullYear();

  return `${todate < 10 ? "0" : ""}${todate}/${tomonth < 10 ? "0" : ""
    }${tomonth}/${toyear}`;
};

export const formatPayDate = (timestamp) => {
  if (
    typeof timestamp === "string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(timestamp)
  ) {
    const [year, month, day] = timestamp.split("-");
    return `${day}/${month}/${year}`;
  }

  const normalized = normalizeTimestamp(timestamp);
  if (!normalized) return "";
  const date = new Date(normalized);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day < 10 ? "0" : ""}${day}/${month < 10 ? "0" : ""
    }${month}/${year}`;
};



export const renderMessageWithLinks = (message) => {
  // Check if the message contains HTML tags
  const containsHtmlTags = /<\/?[\w\s="/.':;#-/?]+>/gi.test(message);

  if (containsHtmlTags) {
    const cleanMessage = DOMPurify.sanitize(message);
    // Render HTML tags using dangerouslySetInnerHTML
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `<div style="line-height: 2.5rem; text-align: center; display: flex; justify-content: center; align-items: center;  padding-left: 2px; padding-right: 2px;">${cleanMessage}</div>`,
        }}
      />
    );
  } else {
    // Regular expression to find URLs in the message
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Split the message based on the URLs found and wrap URLs with <a> tags
    return message.split(urlRegex).map((part, index) => {
      const isWhatsAppChannel =
        /https?:\/\/(www\.)?whatsapp\.com\/channel\/[a-zA-Z0-9]+/.test(part);
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "rgba(0, 0, 255, 0.6)",
              textDecoration: "underline",
            }}
            onClick={(e) => {
              if (isWhatsAppChannel) {
                e.preventDefault();
                window.location.href = part;
              }
            }}
          >
            {isWhatsAppChannel ? "Join WhatsApp Channel" : part}
          </a>
        );
      } else {
        return part;
      }
    });
  }
};

export const renderMessageWithLinksDesc = (message) => {
  // Check if the message contains HTML tags
  const containsHtmlTags = /<\/?[\w\s="/.':;#-/?]+>/gi.test(message);

  if (containsHtmlTags) {
    const cleanMessage = DOMPurify.sanitize(message);
    // Render HTML tags using dangerouslySetInnerHTML
    return (
      <div dangerouslySetInnerHTML={{ __html: `<div>${cleanMessage}</div>` }} />
    );
  } else {
    // Regular expression to find URLs in the message
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Split the message based on the URLs found and wrap URLs with <a> tags
    return message.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "rgba(0, 0, 255, 0.6)",
              textDecoration: "underline",
            }}
          >
            {part}
          </a>
        );
      } else {
        return part.split('\n').map((line, i, arr) => (
          <React.Fragment key={`${index}-${i}`}>
            {line}
            {i !== arr.length - 1 && <br />}
          </React.Fragment>
        ));
      }
    });
  }
};

export const formatterTimePaid = (time_paid) => {
  if (time_paid) {
    const timestamp = normalizeTimestamp(time_paid);
    if (!timestamp) return time_paid;
    const date = new Date(timestamp);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
  return time_paid;
};

export const NOT_REGISTERED_MESSAGE =
  "This phone number/email is not registered for this collection. Contact your group/collection admin to add you or update your contacts to proceed.";

export const getYoutubeEmbedUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};

export const formatterPaidBy = (paidBy) => {
  if (paidBy) {
    if (/\b254\d{9}\b/.test(paidBy)) {
      paidBy = paidBy.replace(/\b254\d{9}\b/, "").trim();
    } else if (/\b07\d{8}\b/.test(paidBy)) {
      paidBy = paidBy.replace(/\b07\d{8}\b/, "").trim();
    }
  }

  return paidBy;
};
